import React from 'react';
import NPS from '../assets/nps.svg';
import Score from '../assets/score-equation.svg';
export default () => {
  return (
    <div className="bg-gray-100 py-8">
      <div className="container text-center mt-8 mb-6">
        <h2 className="leading-none md:leading-normal font-sans text-shop-dark-green text-4xl">
          Ok, but what is NPS?
        </h2>
      </div>

      <div className="container flex flex-row flex-wrap mb-8 justify-center">
        <p className="leading-normal text-center font-sans text-shop-dark-green mt-4 lg:w-2/3 mb-8">
          Net Promoter Score (NPS) is a tool used to gauge customer loyalty for
          a shop/brand's products. It's a simple one-question survey with an
          open-ended answer. 'How likely are you to recommend our product or
          service to a friend?' The customer gives an answer between 0 and 10. 0
          being very unlikely, and 10 is very likely they will recommend your
          shop. The responses are then broken down into three categories;
          Detractors (0-6), Passives (7-8) and Promoters (9-10).
        </p>
      </div>

      <div className="container justify-center mb-10 flex">
        <div className="nps-block bg-white shadow-lg border-t-8 border-shop-light-green rounded-lg py-8 px-4 content-center flex flex-col text-center">
          <p className="font-sans text-shop-dark-green sm:w-1/2 mb-6 sm:mb-10 self-center sm:text-xl font-bold">
            How likely are you to recommend our product or service to a friend?
          </p>
          <NPS className="self-center mb-6 sm:mb-10 max-w-full" />
          <Score className="self-center sm:w-1/2 max-w-full" />
        </div>
      </div>

      <div className="container flex flex-wrap flex-row mb-12 pt-10">
        <div className="w-full md:w-1/3 md:px-6 mb-6">
          <h3 className="leading-normal font-sans text-shop-dark-green text-2xl text-center">
            Detractors
          </h3>
          <p className="leading-normal text-center font-sans text-shop-dark-green">
            A detractor is a customer who will most likely not shop at your
            store anymore, but might also tell others to avoid your shop.
          </p>
        </div>
        <div className="w-full md:w-1/3 md:px-6 mb-6">
          <h3 className="leading-normal font-sans text-shop-dark-green text-2xl text-center">
            Passives
          </h3>
          <p className="leading-normal text-center font-sans text-shop-dark-green">
            A passive customer is one who generally liked the experience, but
            usually won't go out of their way to promote your shop.
          </p>
        </div>
        <div className="w-full md:w-1/3 md:px-6 mb-6">
          <h3 className="leading-normal font-sans text-shop-dark-green text-2xl text-center">
            Promoters
          </h3>
          <p className="leading-normal text-center font-sans text-shop-dark-green">
            A promoter customer is highly likely to shop at your store again,
            and tell others about it as well.
          </p>
        </div>
      </div>
    </div>
  );
};
